// extracted by mini-css-extract-plugin
export default {"h1":"heading_h1__pCNMB","h2":"heading_h2__Qhg0s","h3":"heading_h3__poM9U"};